export { escapeSpecialChars } from './escape-special-chars'
